import axios from 'axios';
import { APIChatUrl, APIUrlToken } from '../../../Utils/Utils';

export const submitFeedback = (payload) => {
  return axios({
    method: 'POST',
    headers: {
      'access-control-allow-origin': '*',
      'content-type': 'application/json',
      'X-API-Key': APIUrlToken(),
    },
    data: payload,
    url: `${APIChatUrl()}/chat/feedback`,
  });
};
